import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_NEWLY_CREATED_PETITIONS = defineFcm('petition_page_newly_created_petitions')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'Petition details page',
		description: 'When enabled, shows a row of petition cards for newly created petitions',
	});
